import type { CartItem, DetailedCartItem, NewCartItem } from './models';
import { generateId } from 'util/generateId';

const CART_KEY_BASE = 'colo-cart_';
const CART_EXPIRY_KEY_BASE = 'colo-updated-on_';

export const cartKey = (slug: string) => `${CART_KEY_BASE}${slug}`;
export const cartExpiryKey = (slug: string) => `${CART_EXPIRY_KEY_BASE}${slug}`;

export function isCartItem(cartItem: NewCartItem | CartItem): cartItem is CartItem {
  return !!(cartItem as CartItem).cartId;
}

export function generateDetailedItem(item: CartItem | NewCartItem): DetailedCartItem {
  const subtotal = item.price + item.modifiers.reduce((sum, { price }) => sum + price, 0);
  const total = subtotal * item.quantity;
  const cartId = isCartItem(item) ? item.cartId : generateId();

  return { ...item, subtotal, total, cartId };
}
